<template>
    <div class="cointainer">
        <!-- Modal component -->
        <b-modal id="agentMemberRegisterModal" :title="modals.memberRegistration" @ok="handleModalOkClick" @hidden="reset" size="lg"  ok-title="受講生登録" cancel-title="キャンセル" modal-class="agent-netenglish-modal">

            <div v-if="isSuccess == true" class="text-center">
                <div class="alert alert-success" role="alert">
                    {{ this.message }}
                </div>
            </div>

            <form @submit.prevent="submitForm" autocomplete="off">

                <!-- Registration type -->
                <b-form-group label-class="small mb-1">
                    <label class="small d-block mb-2">登録方法 <span class="text-danger">*</span></label>
                    <b-form-radio-group
                        v-model="form.registrationType"
                        :options="registrationTypeOptions"
                        name="registrationType"
                        size="sm"
                        @change="onRegistrationTypeChange"
                    ></b-form-radio-group>
                </b-form-group>

                <!-- School ID -->
                <b-form-group
                    label-class="small"
                    label-for="schoolIdSuffix"
                    :invalid-feedback="formErrors.schoolIdSuffix"
                    :description="isSchoolIdMode ? 'ログイン時にこのスクールIDを使用します' : '任意：設定するとスクールIDでもログインできます'"
                >
                    <template #label>
                        スクールID
                        <span v-if="isSchoolIdMode" class="text-danger">*</span>
                        <span v-else class="text-muted">（任意）</span>
                    </template>
                    <b-input-group size="sm">
                        <b-input-group-prepend is-text>
                            <span class="text-muted">{{ displaySchoolPrefix }}</span>
                        </b-input-group-prepend>
                        <b-form-input
                            id="schoolIdSuffix"
                            v-model="form.schoolIdSuffix"
                            :state="formErrors.schoolIdSuffix ? false : null"
                            :required="isSchoolIdMode"
                            placeholder="例: Leo または 1001"
                            @input="validateField('schoolIdSuffix')"
                        ></b-form-input>
                    </b-input-group>
                    <small v-if="form.schoolIdSuffix" class="form-text text-muted">
                        登録ID: <strong>{{ fullSchoolId }}</strong>
                    </small>
                </b-form-group>

                <!-- Email Address -->
                <b-form-group label-class="small" label-for="email"
                    :invalid-feedback="formErrors.email"
                    :description="isSchoolIdMode ? 'エージェントのメールから自動発行されるエイリアスです' : null">
                    <template #label>
                        {{ labels.email }} <span class="text-danger">*</span>
                    </template>
                    <b-form-input
                        type="email"
                        id="email"
                        v-model="form.email"
                        :state="formErrors.email ? false : null"
                        :required="!isSchoolIdMode"
                        :readonly="isSchoolIdMode"
                        :class="{ 'bg-light': isSchoolIdMode }"
                        size="sm"
                        :placeholder="emailPlaceholder"
                        @input="validateField('email')"
                    ></b-form-input>
                </b-form-group>

                <b-row>
                    <!-- Japanese Last Name (姓) -->
                    <b-col md="6">
                        <b-form-group label-class="small" label-for="japaneseLastName"
                            :invalid-feedback="formErrors.japaneseLastName">
                            <template #label>
                                {{ labels.japaneseLastName }} <span class="text-danger">*</span>
                            </template>
                            <b-form-input id="japaneseLastName" v-model="form.japaneseLastName"
                                :state="formErrors.japaneseLastName ? false : null" required size="sm"
                                @input="validateField('japaneseLastName')"></b-form-input>
                        </b-form-group>
                    </b-col>

                    <!-- Japanese First Name (名) -->
                    <b-col md="6">
                        <b-form-group label-class="small" label-for="japaneseFirstName"
                            :invalid-feedback="formErrors.japaneseFirstName">
                            <template #label>
                                {{ labels.japaneseFirstName }} <span class="text-danger">*</span>
                            </template>
                            <b-form-input id="japaneseFirstName" v-model="form.japaneseFirstName"
                                :state="formErrors.japaneseFirstName ? false : null" required size="sm"
                                @input="validateField('japaneseFirstName')"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <!-- Last Name (姓・ローマ字) -->
                    <b-col md="6">
                        <b-form-group label-class="small" label-for="lastName"
                            :invalid-feedback="formErrors.lastName">
                            <template #label>
                                {{ labels.lastName }} <span class="text-danger">*</span>
                            </template>
                            <b-form-input id="lastName" v-model="form.lastName"
                                :state="formErrors.lastName ? false : null" required size="sm"
                                @input="validateField('lastName')"></b-form-input>
                        </b-form-group>
                    </b-col>

                    <!-- First Name (名・ローマ字) -->
                    <b-col md="6">
                        <b-form-group label-class="small" label-for="firstName"
                            :invalid-feedback="formErrors.firstName">
                            <template #label>
                                {{ labels.firstName }} <span class="text-danger">*</span>
                            </template>
                            <b-form-input id="firstName" v-model="form.firstName"
                                :state="formErrors.firstName ? false : null" required size="sm"
                                @input="validateField('firstName')"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

                <!-- Nickname -->
                <b-form-group label-class="small" label-for="nickname" :invalid-feedback="formErrors.nickname">
                    <template #label>
                        {{ labels.nickname }} <span class="text-danger">*</span>
                    </template>
                    <b-form-input id="nickname" v-model="form.nickname" :state="formErrors.nickname ? false : null"
                        required size="sm" @input="validateField('nickname')"></b-form-input>
                </b-form-group>

                <b-row>
                    <!-- Gender -->
                    <b-col md="6">

                        <b-form-group label-class="small">
                            <label class="small">{{ labels.gender }} <span class="text-danger">*</span></label>
                            <b-form-radio-group
                                v-model="form.gender"
                                :state="formErrors.gender ? false : null"
                                required
                                size="sm"
                                @input="validateField('gender')"
                            >
                                <b-form-radio value="male" class="small">Male</b-form-radio>
                                <b-form-radio value="female" class="small">Female</b-form-radio>
                            </b-form-radio-group>
                            <b-form-invalid-feedback v-if="formErrors.gender">
                                {{ formErrors.gender }}
                            </b-form-invalid-feedback>
                        </b-form-group>

                    </b-col>
                </b-row>

                <b-alert show variant="info" class="small mb-3">
                    レッスンはマイページ内のブラウザレッスンルーム（MyRoom）で行います。Zoom / Teams の登録は不要です。
                </b-alert>

                <b-row>
                    <b-col md="6">
                        <!-- Password -->
                        <b-form-group label-class="small" label-for="password"
                            :invalid-feedback="formErrors.password">
                            <template #label>
                                {{ labels.password }} <span class="text-danger">*</span>
                            </template>
                            <b-form-input type="password" id="password" v-model="form.password" autocomplete="new-password"
                                :state="formErrors.password ? false : null" required size="sm"></b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col md="6">
                        <!-- Confirm Password -->
                        <b-form-group label-class="small" label-for="confirmPassword"
                            :invalid-feedback="formErrors.confirmPassword">
                            <template #label>
                                {{ labels.confirmPassword }} <span class="text-danger">*</span>
                            </template>
                            <b-form-input type="password" id="confirmPassword" v-model="form.confirmPassword"
                                :state="formErrors.confirmPassword ? false : null" required size="sm"
                                @input="validateField('confirmPassword')"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

            </form>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: {
        memberships: Array,
        csrf_token: String,
        api_token: String,
        agent_info: Object,
        agent_user_id: Number,
        agent_email: {
            type: String,
            default: ''
        },
        school_prefix: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            modals: {
                memberRegistration: '受講生登録'
            },
            isLoading: false,
            isSuccess: false,
            aliasLoading: false,
            aliasRequestId: 0,
            message: '',
            registrationTypeOptions: [
                { text: 'スクールIDで登録', value: 'school_id' },
                { text: 'メールアドレスで登録', value: 'email' },
            ],
            form: {
                registrationType: 'school_id',
                schoolIdSuffix: '',
                email: '',
                japaneseLastName: '',
                japaneseFirstName: '',
                firstName: '',
                lastName: '',
                nickname: '',
                gender: '',
                communicationApp: '',
                communicationUsername: '',
                password: '',
                confirmPassword: ''
            },
            formErrors: {
                schoolIdSuffix: null,
                email: null,
                japaneseLastName: null,
                japaneseFirstName: null,
                firstName: null,
                lastName: null,
                nickname: null,
                gender: null,
                communicationApp: null,
                communicationUsername: null,
                password: null,
                confirmPassword: null
            },
            fieldNames: {
                schoolIdSuffix: 'スクールID',
                email: 'メールアドレス',
                japaneseLastName: '姓',
                japaneseFirstName: '名',
                firstName: '名（ローマ字）',
                lastName: '姓（ローマ字）',
                nickname: 'ニックネーム（ローマ字）講師が呼びやすいネーム（例：ファ-ストネーム)',
                gender: '性別',
                communicationApp: '通信アプリ',
                communicationUsername: '通信アプリのID',
                password: 'パスワード',
                confirmPassword: 'パスワードを認証する'
            },
            labels: {
                email: 'メールアドレス',
                japaneseLastName: '姓',
                japaneseFirstName: '名',
                firstName: '名（ローマ字）',
                lastName: '姓（ローマ字）',
                nickname: 'ニックネーム（ローマ字）講師が呼びやすいネーム（例：ファ-ストネーム)',
                gender: '性別',
                communicationApp: '通信アプリ',
                communicationUsername: '通信アプリのID',
                password: 'パスワード',
                confirmPassword: 'パスワードを認証する'
            }
        };
    },
    computed: {
        isSchoolIdMode() {
            return this.form.registrationType === 'school_id';
        },
        displaySchoolPrefix() {
            const raw = (this.school_prefix || '').replace(/\s+/g, '').trim();
            return raw ? (raw + '-') : '(未設定)-';
        },
        fullSchoolId() {
            if (!this.form.schoolIdSuffix) {
                return '';
            }
            return this.displaySchoolPrefix + this.form.schoolIdSuffix.trim();
        },
        emailPlaceholder() {
            if (this.isSchoolIdMode) {
                return this.aliasLoading ? '読み込み中...' : '';
            }
            return 'メールアドレスを入力してください';
        }
    },
    mounted() {
        window.openAgentMemberRegisterModal = () => this.openAgentMemberRegisterModal();
        this.$nextTick(() => {
            if (typeof window.consumeAgentManualPendingAction === 'function') {
                window.consumeAgentManualPendingAction('openAgentMemberRegisterModal', () => {
                    this.openAgentMemberRegisterModal();
                });
            }
        });
    },
    methods: {
        reset() {
            this.isLoading = false;
            this.isSuccess = false;
            this.aliasLoading = false;
            this.aliasRequestId++;
            this.message = '';
            this.form = {
                registrationType: 'school_id',
                schoolIdSuffix: '',
                email: '',
                japaneseLastName: '',
                japaneseFirstName: '',
                firstName: '',
                lastName: '',
                nickname: '',
                gender: '',
                communicationApp: '',
                communicationUsername: '',
                password: '',
                confirmPassword: ''
            };

            this.formErrors = {
                schoolIdSuffix: null,
                email: null,
                japaneseLastName: null,
                japaneseFirstName: null,
                firstName: null,
                lastName: null,
                nickname: null,
                gender: null,
                communicationApp: null,
                communicationUsername: null,
                password: null,
                confirmPassword: null
            };
        },
        onRegistrationTypeChange() {
            this.$set(this.formErrors, 'schoolIdSuffix', null);
            this.$set(this.formErrors, 'email', null);

            // Invalidate any in-flight alias preview requests
            this.aliasRequestId++;
            this.aliasLoading = false;

            if (this.isSchoolIdMode) {
                this.fetchAliasEmail();
            } else {
                this.form.email = '';
            }
        },
        fetchAliasEmail() {
            const requestId = ++this.aliasRequestId;
            this.aliasLoading = true;
            this.form.email = '';

            axios.post("/api/preview_agent_member_alias?api_token=" + this.api_token, {
                agent_user_id: this.$props.agent_user_id,
            }).then(response => {
                // Ignore stale responses after the user switched modes
                if (requestId !== this.aliasRequestId || !this.isSchoolIdMode) {
                    return;
                }

                this.aliasLoading = false;
                if (response.data.success) {
                    this.form.email = response.data.email;
                    this.$set(this.formErrors, 'email', null);
                } else {
                    this.form.email = '';
                    alert(response.data.message || 'エイリアスメールの取得に失敗しました');
                }
            }).catch((error) => {
                if (requestId !== this.aliasRequestId || !this.isSchoolIdMode) {
                    return;
                }
                this.aliasLoading = false;
                this.form.email = '';
                alert("Error " + error);
            });
        },
        validateForm() {
            let isValid = true;
            const optionalFields = ['communicationApp', 'communicationUsername', 'registrationType'];

            if (!this.isSchoolIdMode) {
                optionalFields.push('schoolIdSuffix');
            }

            if (this.isSchoolIdMode) {
                optionalFields.push('email'); // server regenerates; still show preview
            }

            Object.keys(this.form).forEach(field => {
                if (optionalFields.includes(field)) {
                    return;
                }
                if (!this.form[field]) {
                    this.$set(this.formErrors, field, `${this.fieldNames[field]} が必要です`);
                    isValid = false;
                }
            });

            if (this.isSchoolIdMode) {
                if (!this.form.schoolIdSuffix || !this.form.schoolIdSuffix.trim()) {
                    this.$set(this.formErrors, 'schoolIdSuffix', 'スクールID が必要です');
                    isValid = false;
                } else if (!/^[A-Za-z0-9_-]+$/.test(this.form.schoolIdSuffix.trim())) {
                    this.$set(this.formErrors, 'schoolIdSuffix', '英数字・ハイフン・アンダースコアのみ使用できます');
                    isValid = false;
                }
            } else if (this.form.schoolIdSuffix && this.form.schoolIdSuffix.trim()) {
                if (!/^[A-Za-z0-9_-]+$/.test(this.form.schoolIdSuffix.trim())) {
                    this.$set(this.formErrors, 'schoolIdSuffix', '英数字・ハイフン・アンダースコアのみ使用できます');
                    isValid = false;
                }
            }

            if (!this.isSchoolIdMode) {
                const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!this.form.email || !emailPattern.test(this.form.email)) {
                    this.$set(this.formErrors, 'email', '有効なメールアドレスを入力してください');
                    isValid = false;
                }
            }

            if (this.form.password !== this.form.confirmPassword) {
                this.$set(this.formErrors, 'confirmPassword', 'パスワードが一致しません');
                isValid = false;
            }

            if (!(this.school_prefix || '').replace(/\s+/g, '').trim() && (this.isSchoolIdMode || (this.form.schoolIdSuffix && this.form.schoolIdSuffix.trim()))) {
                this.$set(this.formErrors, 'schoolIdSuffix', 'エージェントの英語名が未設定です');
                isValid = false;
            }

            return isValid;
        },
        validateField(fieldName) {
            this.$set(this.formErrors, fieldName, null);

            if (fieldName === 'schoolIdSuffix') {
                if (this.isSchoolIdMode && !this.form.schoolIdSuffix) {
                    this.$set(this.formErrors, 'schoolIdSuffix', `${this.fieldNames.schoolIdSuffix} が必要です`);
                } else if (this.form.schoolIdSuffix && !/^[A-Za-z0-9_-]+$/.test(this.form.schoolIdSuffix.trim())) {
                    this.$set(this.formErrors, 'schoolIdSuffix', '英数字・ハイフン・アンダースコアのみ使用できます');
                }
                return;
            }

            if (!this.form[fieldName]) {
                if (!(fieldName === 'email' && this.isSchoolIdMode) && !(fieldName === 'schoolIdSuffix' && !this.isSchoolIdMode)) {
                    this.$set(this.formErrors, fieldName, `${this.fieldNames[fieldName]} が必要です`);
                }
            }

            if (fieldName === 'email' && !this.isSchoolIdMode) {
                const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailPattern.test(this.form.email)) {
                    this.$set(this.formErrors, 'email', '有効なメールアドレスを入力してください');
                }
            }

            if (fieldName === 'password' || fieldName === 'confirmPassword') {
                if (this.form.password !== this.form.confirmPassword) {
                    this.$set(this.formErrors, 'confirmPassword', 'パスワードが一致しません');
                }
            }
        },
        openAgentMemberRegisterModal()
        {
            this.$bvModal.show('agentMemberRegisterModal');
            if (this.isSchoolIdMode) {
                this.fetchAliasEmail();
            }
        },
        closeAgentMemberRegisterModal() {
            this.$bvModal.hide('agentMemberRegisterModal');
            this.reset();
        },
        handleModalOkClick($event) {
            $event.preventDefault();
            this.submitForm();
        },
        submitForm() {
            if (this.validateForm()) {
                this.form.attribute = 'member';
                this.form.communicationApp = 'webrtc';
                this.form.communicationUsername = '';

                axios.post("/api/create_agent_member?api_token=" + this.api_token, {
                    method: "POST",
                    form: JSON.stringify(this.form),
                    agent_user_id: this.$props.agent_user_id,
                }).then(response => {
                    console.log(response)
                    if (response.data.success === false) {
                        alert(response.data.message);
                    } else {
                        this.isSuccess = true;
                        let msg = response.data.message;
                        if (response.data.school_id) {
                            msg += '（スクールID: ' + response.data.school_id + '）';
                        }
                        this.message = msg;
                        setTimeout(() => {
                            this.closeAgentMemberRegisterModal();
                            this.reset();
                        }, 2500);
                    }

                }).catch(function (error) {
                    alert("Error " + error);
                });
            }
        },

    }
};
</script>
